<template>
    <div>
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Menu'"/>
        </div>
        <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Estrategico Institucional por Organismo Público</h1>
        </div>
        <select3Filtros id="selectFiltroEIOP" :data="data" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" :placeholder1="'Año'" :placeholder2="'Tomo'"/>
        <!-- {{ responseSelectComponent }} -->
        <div>
            <div v-if="contenidoAnio" class="col-md-12 mt-3"> 
                <h5>{{textoTitulo}}</h5>
                <div v-if="flagArrays"><!---Aplica para los objetos que tienen más de un array como propiedad---->
                    <!-- {{ contenidoAnio }} -->
                    <div class="accordion mt-2 mb-5" id="accordionExample">
                        <div v-for="(section, index) in contenidoAnio" :key="index" class="card">
                            <div class="card-header" :class="section.secciones.length == 0? 'card-header-archivo' : ''" :id="'heading' + index">
                                <h2 class="mb-0">
                                    <button
                                        class="btn btn-link btn-block text-left"
                                        type="button"
                                        data-toggle="collapse"
                                        :data-target="'#collapse' + index"
                                        aria-expanded="true"
                                        :aria-controls="'collapse' + index"
                                        style="display: flex; justify-content: space-between;"
                                    >
                                        <span class="titulo-collapse"><a :href="section.url_pdf != ''? urlServe + section.url_pdf : '#'" target="_blank">{{ section.titulo }}</a></span>
                                        <span v-if="section.secciones.length > 0" class="descargar"><i class="bx bx-chevron-down icono-down"></i></span>
                                        <span v-else class="descargar-pdf">
                                            <a :href="section.url_pdf != ''? urlServe + section.url_pdf : '#'" target="_blank">
                                                <i class="fas fa-file-pdf text-danger"></i>
                                            </a>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    :id="'collapse' + index"
                                    class="collapse"
                                    :aria-labelledby="'heading' + index"
                                    data-parent="#accordionExample"
                                >
                                    <div v-if="section.secciones.length > 0" class="card-body">
                                        <div v-for="(apartado, a) in section.secciones" :key="a">
                                            <ul class="nvl_1_acordeon">
                                                <li v-if="apartado.titulo_seccion != ''" class="subtitulo">
                                                    <span v-if="apartado.hasOwnProperty('url_pdf')">
                                                        <a :href="urlServe + apartado.url_pdf" target="_blank">{{ apartado.titulo_seccion }}</a>
                                                    </span>
                                                    <span v-else>{{ apartado.titulo_seccion }}</span>
                                                </li>
                                            </ul>
                                            <div v-if="apartado.hasOwnProperty('contenido_seccion')"> 
                                                <!-- Aqui recorrido modelo 5 y 9-->
                                                <div v-for="(contenido_seccion, cs) in apartado.contenido_seccion" :key="cs">
                                                    <ul class="nvl_2_acordeon">
                                                        <li v-if="contenido_seccion.subtitulo_seccion != ''" class="subsubtitulo">
                                                            <span v-if="contenido_seccion.hasOwnProperty('url_pdf')">
                                                                <a :href="urlServe + contenido_seccion.url_pdf" target="_blank">{{ contenido_seccion.subtitulo_seccion }}</a>
                                                            </span>
                                                            <span v-else>{{ contenido_seccion.subtitulo_seccion }}</span>
                                                        </li>
                                                    </ul>
                                                    <div v-for="(contenido_subseccion, csub) in contenido_seccion.contenido" :key="csub">
                                                        <ul class="nvl_3_acordeon">
                                                            <li v-if="contenido_subseccion.subsubtitulo_seccion != ''">
                                                                <span v-if="contenido_subseccion.hasOwnProperty('url_pdf')">
                                                                    <span v-if="contenido_subseccion.url_pdf != ''">
                                                                        <a :href="urlServe + contenido_subseccion.url_pdf" target="_blank" class="subsubsubtitulo">{{ contenido_subseccion.subsubtitulo_seccion }}</a>
                                                                    </span>
                                                                    <span v-else class="subsubsubtitulo">{{ contenido_subseccion.subsubtitulo_seccion }}</span>
                                                                </span>
                                                                <span v-else class="subsubsubtitulo">{{ contenido_subseccion.subsubtitulo_seccion }}</span>
                                                            </li>
                                                        </ul>
                                                        <!-- <pre>{{ contenido_subseccion }}</pre> -->
                                                        <ul v-for="(archivo_subseccion, asub) in contenido_subseccion.archivos_seccion" :key="asub" class="nvl_4_acordeon">
                                                            <li class="archivo_subsubsub">
                                                                <a :href="urlServe + archivo_subseccion.url_pdf" target="_blank">{{ archivo_subseccion.titulo }}</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <!-- <pre>{{ apartado }}</pre> -->
                                                <!----Modelo 4-->
                                                <ul v-if="apartado.subtitulo_seccion != ''">
                                                    <li class="sub">
                                                        {{ apartado.subtitulo_seccion }}
                                                    </li>
                                                </ul>
                                                <ul v-for="(archivo, r) in apartado.archivos_seccion" :key="r" class="nvl_4_acordeon">
                                                    <li class="archivo_subsubsub">
                                                        <a :href="urlServe + archivo.url_pdf" target="_blank">{{ archivo.titulo }}</a>
                                                    </li>
                                                </ul>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="card-body pt-0"> <!----Aplica para los que no tienen o solo tienen un array (mod 2 y 7)----->
                    <div v-for="(contenido, i) in contenidoAnio" :key="i" class="m-0">
                        <span v-if="(contenido.titulo != '' && contenido.url_pdf) && contenido.hasOwnProperty('contenido') == false" >
                            <ul><li class="only_archivo"><a class="" :href="urlServe + contenido.url_pdf" target="_blank">{{ contenido.titulo }}</a></li></ul>
                        </span>
                        <span v-else>
                            <ul class="subtitulo"><li><a :href="urlServe + contenido.url_pdf" target="_blank">{{ contenido.titulo }}</a></li></ul>
                            <div v-if="contenido.contenido.length > 0" class="contenedor-archivos">
                                <ul v-for="(archivo, ar) in contenido.contenido" :key="ar">
                                    <li class="archivo"><a class="" :href="urlServe + archivo.url_pdf" target="_blank">{{ archivo.titulo }}</a></li>
                                </ul>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <span v-html="fecha_actualizacion"></span>
    </div>
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import EstrategicoIns from "@/services/rendicionDeCuentas/estrategicoInstitucionalporOrgPub/estratetigoInstOrgPub.js";
import selectEjercicio from "../../../components/selectSingle.vue";
import cardCollapse from "../../../components/cardCollapse.vue";
import cardCollapseDocs from '../../../components/cardCollapseDocs.vue';
import botonAtras from '../../button-atras.vue';
import select3Filtros from '@/components/selectCompuesto3.vue'
import DateFormat from "@/mixins/dateFormatMixin.js";
const _serviciosEstrategicoIns = new EstrategicoIns();
export default {
    mixins: [DateFormat],
    components: { selectEjercicio, cardCollapse, cardCollapseDocs, botonAtras, select3Filtros },
    created(){
        window.scrollTo(0, 0);
        this.getListAniosyTomos();
    },
    data(){
        return{
            contenidoAnio: [],
            flagArrays: null,
            data: [],
            responseSelectComponent: { select: "", fecha_actualizacion:'', selectedSeccion: { id: 0, text: "", fecha_actualizacion:'' } },
            textoTitulo: '',
            fecha_actualizacion: '',
        }
    },
    methods:{
        async getListAniosyTomos() {
            try {
                let response_anios = await _serviciosEstrategicoIns.getListadoAnios(mapFun.EIOPListAniosTomos);
                this.fecha_actualizacion = this.DateFormatText(response_anios.data[response_anios.data.length -1].fecha_actualizacion);
                this.data = response_anios.data.reverse();
                this.data = this.data.map(function (e) {
                    return {
                        id:       e.id,
                        text:     e.titulo,
                        fecha_actualizacion: e.fecha_actualizacion,
                        seccion:  e.contenido
                    };
                });
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getContenido(){
            try {
                let ruta = mapFun.EIOPInfo;
                let ruta_completa = null;
                let anio_seleccionado = this.responseSelectComponent.select;
                if(Object.keys(this.responseSelectComponent.selectedSeccion).length === 0){
                    this.fecha_actualizacion = this.DateFormatText(this.responseSelectComponent.fecha_actualizacion);
                    ruta_completa = ruta+anio_seleccionado+".json";
                }else{
                    this.fecha_actualizacion = this.DateFormatText(this.responseSelectComponent.selectedSeccion.fecha_actualizacion);
                    let numeroRomano = await this.responseSelectComponent.selectedSeccion.text.replace("Tomo ", '');
                    ruta_completa = ruta+anio_seleccionado+"-T"+numeroRomano+".json";
                }
                let response_contenidoAnio = await _serviciosEstrategicoIns.getContenidoAnio(ruta_completa);
                this.contenidoAnio = response_contenidoAnio.data;
            } catch (error) {
                console.log('error', error.message);
            }
        },
    },
    watch: {
        contenidoAnio(){
            if(this.contenidoAnio.length > 0){ /////this.contenidoAnio && !this.verSelectTomo) || (this.anioSeleccionado && this.tomoSeleccionado)
                let obj_prueba = this.contenidoAnio[0];
                // console.log("obj_prueba", obj_prueba);
                this.flagArrays = obj_prueba.hasOwnProperty("secciones")
            }
        },
        responseSelectComponent(){
            if(this.responseSelectComponent && this.responseSelectComponent.select == ''){ /// cuando sea un año con tomos, limpiar la información anterior
                this.contenidoAnio = []
            }
        },
        'responseSelectComponent.select'(){
            if(this.responseSelectComponent.select && Object.keys(this.responseSelectComponent.selectedSeccion).length == 0){this.getContenido();} /// para lo que no tienen tomos
        },
        'responseSelectComponent.selectedSeccion.id'(){
            if(this.responseSelectComponent.selectedSeccion.id){this.getContenido();} //para los que si tienen tomos
        }
    },
}
</script>
<style scoped>
.card-body .subtitulo{border-bottom: 1px solid #cfcfcf; width: 100%; margin-top: 0 !important;} 
.card-body .subtitulo a{font-size: 1rem; color:#6c757d;} 

/* a{color: #212529;} */
a:hover{color: #212529; text-decoration: none; transform: scale(1.01);}
.contenedor-archivos{margin-top: 0.5rem;}
ul {
  padding-left: 0;
  margin: 0;
}
ul li{
    list-style-type: none;
    list-style: none;
}
ul li a{color: #212529;}
ul li.archivo{
    border-bottom: 1px dotted #cfcfcf;
    margin-bottom: 0.3rem;
    margin-left: 3rem;
    font-size: 15px;
}
ul li.only_archivo{
  margin-bottom: 1rem;
  border-bottom: 1px solid #cfcfcf;
  padding: 0.2rem 0;
  font-size: 15px;
  transition: ease all .1s;
}
 ul li:hover {
  transform: scale(1.01);
}

.accordion .card .card-header {
    border-radius: 0!important;
    margin-bottom: -1px!important;
    background-color: #fff!important;
}
.card-header:first-child {
      border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0!important;
}
.card-header {
      padding: .75rem 1.25rem!important;
      margin-bottom: 0!important;
      background-color: rgba(0, 0, 0, .03)!important;
      border-bottom: 1px solid rgba(0, 0, 0, .125)!important;
}
.card-header .titulo-collapse a{
      color:#621132;
}
.card-header.card-header-archivo{
    padding: 0 1.25rem !important;
    margin-bottom: 0;
}
.nvl_1_acordeon{margin: .5rem 0;}
.nvl_1_acordeon .subtitulo{
    font-size: 1.1rem;
    color:#6c757d;
}
.nvl_2_acordeon{margin-left: 1rem;}
.nvl_2_acordeon .subsubtitulo{font-size: 0.98rem; font-weight: 500; color:#621132; border-bottom: 1px dotted #cfcfcf; margin-bottom: .5rem;}

.nvl_3_acordeon{margin-left: 1.6rem;}
.nvl_3_acordeon .subsubsubtitulo{font-size: .95rem; font-weight: 500; color:#635e60 !important; margin-bottom: .3rem; border-bottom: 1px dotted #cfcfcf;}

.nvl_4_acordeon{margin-left: 2.3rem;}
.nvl_4_acordeon .archivo_subsubsub{font-size: .95rem;color:#635e60; margin-bottom: .5rem; border-bottom: 1px dotted #cfcfcf;}
</style>